import { PokerRoom } from './model/enumeration/PokerRoom';
import { UserSettings } from './model/settings/UserSettings';

export const MIN_USER_PASSWORD_LENGTH = 6;
export const MIN_USERNAME_LENGTH = 3;

export const WIN_EVENT_DELAY = 1500;

export const TARGET_EMOJI_ANIMATION_TIME = 1700;
export const TARGET_EMOJI_ANIMATION_START_DELAY = 40;

export const VIEWING_TABLE_INSERTION_TIMEOUT = 500;
export const NEW_TABLES_FIRST = true;

export const UPDATE_ACTIVE_TAB_TIMEOUT = 30000;
export const ACTIVE_TAB_EXPIRATION = UPDATE_ACTIVE_TAB_TIMEOUT * 10;

export const UPDATE_TIME_SHIFT_TIMEOUT = 30000;

export const UPDATE_LOBBY_EXPERT_MODE_TIMEOUT = 20000;

export const ANTI_SPAM_DELAY = 2000;

export const MIN_EXPERT_MODE_SCREEN_WIDTH = 1550;

export const DEFAULT_SETTINGS: UserSettings = {
  chat: {
    textSettings: {
      notifications: true,
      sound: true,
      hideNotificationsDelay: 10000,
      audio: null,
    },
    emojiSettings: {
      notifications: true,
      sound: true,
      hideNotificationsDelay: 10000,
      audio: null,
    },
    disabled: false,
    language: 'ENGLISH',
  },
  newLivePlayerNotifications: {
    notifications: false,
    sound: false,
    hideNotificationsDelay: 10000,
    audio: null,
  },
  livePlayerWonNBBNotifications: {
    notifications: false,
    sound: false,
    hideNotificationsDelay: 10000,
    audio: null,
  },
  botLeftTableNotifications: {
    notifications: false,
    sound: false,
    hideNotificationsDelay: 10000,
    audio: null,
  },
  livePlayerBetStraddleNotifications: {
    notifications: false,
    sound: false,
    hideNotificationsDelay: 10000,
    audio: null,
  },
  table: {
    autoCloseTables: 60000,
    manualBotMoveControl: false,
    limsX100: true,
    askBuyInBeforeSit: false,
    countryFlag: true,
    vpip: true,
    lightMode: false,
    expertMode: false,
    rebuy: false,
  },
  pushNotifications: {
    enabled: false,
  },
};

export const DEFAULT_AUTO_FILTER_OPTIONS = true;

export const MAX_AUDIO_FILE_SIZE = 500 * 1024;
export const ALLOWED_AUDIO_FILE_TYPES = [
  'audio/mpeg',
  'audio/wav',
  'audio/x-wav',
];

export const DEFAULT_BACKEND_SUCCESS_NOTIFICATION_CLOSE_DELAY = 10000;

export const DEFAULT_CHAT_HEIGHT = 660;

export const DEFAULT_GENERATED_PASSWORD_LENGTH = 20;

export const REFRESH_LOBBY_TABLES_INTERVAL = 10000; // 10 sec

export const REFRESH_BOTS_FOR_SEAT_WITH_CLUBS_INTERVAL = 5000; // 5 sec

export const REFRESH_BOTS_FOR_SEAT_INTERVAL = 5000; // 5 sec

export const REFRESH_LOBBY_TABLES_INTERVAL_EXPERT_MODE = 5000; // 5 sec

export const REFRESH_AVAILABLE_BOTS_INTERVAL = 10000; // 10 sec

export const getBackendApiPort = (): number =>
  Number(process.env.REACT_APP_BACKEND_PORT) || 8080;

export const WEBSOCKET_DESTINATION_PREFIX = '/hammer-fell';

export const COUNTRY_FLAGS_API =
  'https://raw.githubusercontent.com/lipis/flag-icons/main/flags/4x3/';

export const getPokerRoom = (): PokerRoom =>
  (process.env.REACT_APP_POKER_ROOM as PokerRoom) || PokerRoom.ClubGG;

export const getVapidPublicKey = (): string =>
  process.env.REACT_APP_VAPID_PUBLIC_KEY ||
  'BBAwfEBdos6qPrg6_Ufvdq_yoqpISKxeWH60vOJMGo9vMpHvkGM-Bp31L345NjS9QoNdKVuuFJh67JuS7FP2o2M';

const pokerRoomAliases = new Map<PokerRoom, string>([
  ...Object.values(PokerRoom).map(room => [room, room] as [PokerRoom, string]),
  [PokerRoom.EbPoker, 'Eb-poker'],
]);

export const getPokerRoomAlias = (): string =>
  pokerRoomAliases.get(getPokerRoom());
